import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../../environments/environment';
import { Elate } from '../../../model/elate.model';
import {
  IdentityVerification,
  IdentityVerificationSessionResponse,
} from '../../../model/identity-verification.model';
import { BaseStripeIdentityComponent } from '../base-stripe-identity.component';



@Component({
  selector: 'lib-ai-exam-onboarding-stripe-identity',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  templateUrl: './AI-exam-onboarding-stripe-identity.component.html',
  styleUrls: ['./AI-exam-onboarding-stripe-identity.component.scss'],
})
export class AIExamOnboardingStripeIdentityComponent extends BaseStripeIdentityComponent implements OnInit, OnDestroy {

  @Input() elate!: Elate | null;
  @Output() verified = new EventEmitter<void>();

  // ─── Abstract implementations ────────────────────────────────────────────────

  protected override get stripePublicKey(): string | undefined {
    return (environment as { stripePublicKey?: string }).stripePublicKey;
  }

  protected override isInputReady(): boolean {
    return !!this.elate?.token;
  }

  protected override callStartVerification(): Observable<IdentityVerificationSessionResponse> {
    return this.identityService.startFlashlevelVerificationExternal(this.elate!.token);
  }

  protected override callGetStatus(): Observable<IdentityVerification> {
    return this.identityService.getFlashlevelVerificationStatusExternal(this.elate!.token);
  }

  protected override callExpireSession(): Observable<unknown> {
    return this.identityService.expireFlashlevelSessionExternal(this.elate!.token);
  }

  protected override onVerified(): void {
    this.verified.emit();
  }

  handleContinue(): void {
    this.verified.emit();
  }
}
